import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Checkbox from 'material-ui/Checkbox';
import Typography from 'material-ui/Typography'
import DialogModal from '../../common/DialogModal';
import TextField from 'material-ui/TextField';
import Button from '../../Parts/Button';
import { FormControl } from 'material-ui/Form';
import { InputLabel } from 'material-ui/Input';
import Chip from 'material-ui/Chip';
import CancelCircle from '../../Icons/CancelCircle';
import * as errMessages from '../../../constants/ErrorMessages'
import { departmentNestedMenu } from '../../../constants/SidebarValues';
import { flattenMap } from '../../../utils/utils';

const styles = () => ({
  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
    width: '600px',
  },

  contentContainer: {
    padding: '25px',
    margin: 0,
  },

  container: {
    background: '#FFFFFF',
    border: '1px solid #D8DBDF',
    padding: '20px',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  row: {
    marginTop: '20px',
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },

  fullWidth: {
    width: '100%',
  },

  input: {
    boxSizing: 'border-box',
  },

  chipRoot: {
    marginRight: '10px',
    marginBottom: '8px',
    float: 'left',
    backgroundColor: 'rgba(26,101,255,.05)',
    border: '#1A65FF solid 1px',
    color: '#181819',
    height: '27px',
    borderRadius: '2px',
  },

  chipLabel: {
    padding: '5px 17px 5px 10px',
    fontSize: '11px',
  },

  labelContainer: {
    display: 'block',
    marginTop: '16px',
  },

  text: {
    marginLeft: '5px',
    fontSize: '14px',
    cursor: 'pointer',
  },
});

class SaveFilterDialog extends React.Component {
  state = {
    name: '',
    filter: this.props.filter,
    filterValue: this.props.filterValue,
    new_exe_notif_flag: false,
    error: {},
    labels: this.props.labels,
  }

  componentWillMount() {
    this.validateForm();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isPostingFilter && !nextProps.isPostingFilter) {
      this.props.toggleDialog();
    }
  }

  handleChange = (e) => {
    let value = e.target.value;

    this.setState({
      name: value,
    }, () => this.validateForm())
  }

  handleCheck = () => {
    this.setState({
      new_exe_notif_flag: !this.state.new_exe_notif_flag,
    })
  }

  handleSave = () => {
    this.props.handlePostExecutiveListFilter({
      name: this.state.name,
      filter: this.overwriteFilter(),
      new_exe_notif_flag: this.state.new_exe_notif_flag ? 1 : 0,
    });
  }

  handleChipsDelete = (property, label) => {
    let filter = { ...this.state.filter };

    if (property === 'keyword') {
      delete filter[property];
    } else if (property === 'exclude_retirement') {
      filter[property] = [true];
    } else {
      if (filter[property].length === 1) {
        delete filter[property];
      } else {
        filter[property] = filter[property].filter(item => item !== label);
      }
    }

    this.setState({
      filter: filter,
      labels: this.state.labels.filter(l => l.value !== label),
    }, () => this.validateForm());
  }

  overwriteFilter() {
    const filterValue = this.props.filterValue;
    const filter = { ...this.props.filter };

    if (filterValue.hasOwnProperty('department')) {
      delete filter['department'];
      let values = flattenMap(filterValue['department'], departmentNestedMenu);

      let params = [];

      values.forEach((key) => {
        params.push(key);
      });

      filter['department'] = params;
    }

    return filter;
  }

  validateForm = () => {
    const { name, filter, labels } = this.state;
    let error = { ...this.state.error };

    if (!name) {
      error['name'] = errMessages.ERR_EMPTY;
    } else {
      delete error['name'];
    }

    if (!filter
      || Object.values(filter).length === 0
      || labels.length === 0) {
      error['filter'] = errMessages.ERR_EMPTY;
    } else {
      delete error['filter'];
    }

    this.setState({
      error: error,
    })
  }

  render() {
    const { classes, toggleDialog, isOpen, isPostingFilter, user } = this.props;
    const { name, error, labels } = this.state;

    let showCheckbox = user ? !!user.new_exe_notif_flag : false;

    return (
      <DialogModal
        title="絞り込み条件を保存"
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer
        }}
      >
        <div className={classes.container}>
          <div className={classes.row}>
            <div className={classes.fullWidth}>
              <TextField
                id="name"
                value={name}
                label="名前"
                InputProps={{
                  disableUnderline: true,
                }}
                InputLabelProps={{ shrink: true, }}
                placeholder="名前を入力"
                onChange={this.handleChange}
                className={classes.input}
                fullWidth
              />
            </div>
          </div>
          <div className={classes.row}>
            <FormControl
              error={error.hasOwnProperty("filter")}
              fullWidth
            >
              <InputLabel shrink={true} disableAnimation={true}>絞り込み条件</InputLabel>
              <div className={classes.labelContainer}>
                {labels.map((label, i) => (
                  <Chip
                    key={i}
                    label={label.name}
                    color="primary"
                    classes={{
                      root: classes.chipRoot,
                      label: classes.chipLabel,
                    }}
                    onDelete={() => this.handleChipsDelete(label.property, label.value)}
                    deleteIcon={<CancelCircle width={15} height={15} color="#6F9EFF" />}
                  />
                ))}
              </div>
            </FormControl>
          </div>
          {showCheckbox && (
            <div
              className={classes.row}
              onClick={this.handleCheck}
            >
              <Checkbox
                color="primary"
                checked={this.state.new_exe_notif_flag}
                onChange={this.handleCheck}
                style={{
                  width: "20px",
                  height: "20px",
                }}
              />
              <Typography
                variant="subheading"
                className={classes.text}
              >
                新任を通知する
              </Typography>
            </div>
          )}
          <Button
            text="保存"
            handleClickButton={this.handleSave}
            style={{ margin: '50px 0' }}
            loading={isPostingFilter}
            disabled={Object.values(this.state.error).length > 0}
          />
        </div>
      </DialogModal>
    );
  }
}

SaveFilterDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isPostingFilter: PropTypes.bool,
  handlePostExecutiveListFilter: PropTypes.func.isRequired,
  filter: PropTypes.object.isRequired,
  filterValue: PropTypes.object,
  labels: PropTypes.array,
  user: PropTypes.object,
};

export default withStyles(styles)(SaveFilterDialog);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/SaveFilterDialog.jsx